import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-reports',
    imports: [
        RouterModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<router-outlet />`
})
export class ReportsComponent {

}
